// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3oNEl","inner":"Form_inner__zfO19","range":"Form_range__1nZu9","name":"Form_name__2PG5l","actions":"Form_actions__1JJrO"};